import React, { useState } from 'react'
import { Container, Grid } from "@material-ui/core"
import styles from './footer.module.css'
import InfoRender from './info_render'
import getStringsBasedLang from '../../strings/get_strings'
import { useNavigate } from 'react-router-dom'
import { apiURL } from '../../api/api_service'

export default function Footer(props) {
    let navigate = useNavigate()
    const lang = localStorage.getItem("lang")

    return (

        <div className={styles.footer_container}>
            <Container>
                <div className={styles.footerLogo_container}>
                    <img className={styles.footerLogo} alt="footerLogo" src={require('../../assets/icons/main_logo.svg').default} />
                </div>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} md={4}>
                        <InfoRender img="mark" text={getStringsBasedLang("footer_address")} />
                        <InfoRender img="phone" text={getStringsBasedLang("footer_phone")} />
                        {/*                         <InfoRender img="fax" text={strings.footer_fax} /> */}
                        <InfoRender img="mail" text={getStringsBasedLang("footer_mail")} />
                    </Grid>
                    <Grid item xs={6} sm={5} md={2}>
                        <div className={styles.footerColumn_parent}>
                            <span className={styles.footerColumn_child_c1} onClick={() => navigate('/')}>{getStringsBasedLang("footer_mainHome")}</span>
                            {/*                             <span className={styles.footerColumn_child_c1}><a className={styles.footerColumn_child_a} target="_blank" rel="noopener noreferrer" href="https://docs.cyberno.ir/fa/blog/rules">{strings.footer_rules}</a></span>
 */}                    <span className={styles.footerColumn_child_c1}><a className={styles.footerColumn_child_a} target="_blank" rel="noopener noreferrer" href={`${(!lang || lang === 'en' ? 'https://docsen.cyberno.ir/en/blog/multiscanner-intro' : 'https://docs.cyberno.ir/fa/blog/multiscanner-intro')}`}>{getStringsBasedLang("general_faq")}</a></span>
                        <span className={styles.footerColumn_child_c1}><a className={styles.footerColumn_child_a} target="_blank" rel="noopener noreferrer" href="https://cyberno.ir/page/about">{getStringsBasedLang("footer_aboutUs")}</a></span>
                        </div>
                    </Grid>
                    <Grid item xs={6} sm={6} md={2}>
                        <div className={styles.footerColumn_parent}>
                            <span className={styles.footerColumn_child_c1} onClick={() => navigate('/search')}><a className={styles.footerColumn_child_a}>{getStringsBasedLang("general_search")}</a></span>
                            <span className={styles.footerColumn_child_c1}><a className={styles.footerColumn_child_a} target="_blank" rel="noopener noreferrer" href={`${(!lang || lang === 'en' ? `${apiURL()}/docs_en/index.html` : `${apiURL()}/docs/index.html`)}`}>{getStringsBasedLang("footer_apiDoc")}</a></span>
                            <span onClick={() => navigate('/aboutApp')} className={styles.footerColumn_child_c1}><a className={styles.footerColumn_child_a}>{getStringsBasedLang("footer_aboutSystem")}</a></span>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <div className='mt-6'>
                            <div className={`${styles.symbol} flex justify-around`}>
                                <div>
                                    <img className={`${styles.govahiname_container} ${styles.enamad}`} alt="senf" src={require('../../assets/icons/senf.png')} />
                                </div>
                                <div>
                                    <img className={`${styles.govahiname_container} ${styles.enamad}`} alt="daneshbonyan" src={require('../../assets/icons/daneshbonyan.png')} />
                                </div>
                            </div>
                        </div>

                    </Grid>
                </Grid>
                <div className={styles.divider} />
                <Grid container spacing={1}>
                    <Grid item sm={12} md={6}>
                        <span className={styles.footerNote}>{getStringsBasedLang("footer_footNote")}</span>
                    </Grid>
                    <Grid style={{ width: "100%" }} item sm={12} md={6}>
                        <div className={styles.footerNoteIcons_parent}>
                            <img className={styles.footerNoteIcons} onClick={() => window.open("https://t.me/cyberno_ir")} alt="footer" src={require('../../assets/icons/tlg.svg').default} />
                            <img className={styles.footerNoteIcons} onClick={() => window.open("https://twitter.com/cyberno_ir")} alt="footer" src={require('../../assets/icons/twitter.svg').default} />
                            <img className={styles.footerNoteIcons} onClick={() => window.open("https://instagram.com/cyberno_ir")} alt="footer" src={require('../../assets/icons/instagram.svg').default} />
                            <img className={styles.footerNoteIcons} onClick={() => window.open("https://www.linkedin.com/company/cyberno")} alt="footer" src={require('../../assets/icons/linkedin.svg').default} />
                            <img className={styles.footerNoteIcons} onClick={() => window.open("https://github.com/cyberno-ir")} alt="footer" src={require('../../assets/icons/github.svg').default} />
                            <img className={styles.footerNoteIcons} onClick={() => window.open("https://ble.ir/cyberno")} alt="footer" src={require('../../assets/icons/bale.svg').default} />
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}
